<template>
  <div class="about-card">
    <div class="about-card_content">
      <p class="paragraph">{{ $t('Можно ли получать игровое золото Tanks Blitz совершенно бесплатно? Не выделяя на его покупку ни копейки из своего бюджета? Так точно! Теперь ты можешь увеличивать свой «золотой запас» в игре без особых усилий и дополнительных затрат с картой Tanks Blitz.') }}
      </p>
      <p class="paragraph">{{ $t('Просто делай свои повседневные покупки и ежемесячно получай часть потраченных денег в виде золота на игровой аккаунт!') }}</p>

      <ul class="about-card_cards-list">
        <li class="about-card_card-item">
          <CardPicture
            :design="design"
            :game="games.TB"
          />
        </li>
      </ul>
    </div>

    <ExpandCollapse @toggle="trackToogleAdditionalFutureList">
      <h2 slot="header">{{ $t('Как это работает?') }}</h2>
      <p class="paragraph" v-html="orderLocalizedLink"/>
      <p class="paragraph">
        {{ $t('Оплачивай картой свои обычные расходы: покупки в магазинах, коммунальные услуги, мобильную связь и т. д.') }}
      </p>
      <p class="paragraph">
        {{ $t('В начале каждого месяца бесплатно получай золото за часть потраченных денег в предыдущем месяце, а также другие бонусы.') }}
      </p>
      <p class="paragraph" v-html="depositLinkAllBanks" />
      <p class="paragraph">{{ $t('Доставка карты курьером во все населенные пункты Беларуси.') }}</p>
    </ExpandCollapse>

    <ExpandCollapse @toggle="trackToogleAdditionalFutureList">
      <h2 slot="header">{{ $t('Какие бонусы даёт карта?') }}</h2>
      <ol class="ordered-list">
        <li class="ordered-list_item ordered-list_item__titled3">
          <h3 class="heading3">{{ $t('Стартовый бонус') }}</h3>
          <p class="paragraph">{{ $t('30 дней премиум аккаунта ты получишь в подарок вместе с первым возвратом золота.') }}</p>
          <p class="paragraph">{{ $t('Начисляется единоразово на аккаунт с первой заказанной картой.') }}</p>
        </li>
        <li class="ordered-list_item ordered-list_item__titled3">
          <h3 class="heading3">{{ $t('Ежемесячный бонус') }}</h3>
          <p class="paragraph">{{ $t('9 золота будут возвращаться тебе на игровой аккаунт за каждые 3 BYN, потраченные с карты.')}}</p>
        </li>
        <li class="ordered-list_item ordered-list_item__titled3">
          <h3 class="heading3">{{ $t('Бонус в Премиум магазине') }}</h3>
          <p class="paragraph">{{ $t('При оплате в Премиум магазине с помощью метода «Карта Леста» тебе будет возвращаться в виде золота 5% от стоимости каждого купленного товара. И это в дополнение к ежемесячному возврату золота, который распространяется в том числе и на покупки в Премиум магазине.') }}</p>
        </li>
      </ol>
    </ExpandCollapse>

    <ExpandCollapse @toggle="trackToogleAdditionalFutureList">
      <h2 slot="header">{{ $t('Как заказать карту Tanks Blitz?') }}</h2>
      <p class="paragraph">{{ $t('Чтобы стать обладателем карты Tanks Blitz, нужно заказать карту на специальной странице заказа карты или обратиться напрямую в Альфа Банк. При заказе карты напрямую в банке ее необходимо привязать к аккаунту на странице привязки, введя бонусный номер, расположенный на лицевой стороне карты.') }}</p>
    </ExpandCollapse>

    <ExpandCollapse @toggle="trackToogleAdditionalFutureList">
      <h2 slot="header">{{ $t('Как бесплатно пополнять карту?') }}</h2>
      <p class="paragraph" v-html="depositLocalizedLink" />
    </ExpandCollapse>

    <ul class="about-card_action">
      <li class="about-card_button">
        <OrderButton game="tb" />
      </li>
      <li class="about-card_link">
        <a :href="getLearnMoreUrl('tb')" class="link link__button" target="_blank">
          {{ $t('Узнать больше') }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { Component } from 'vue-property-decorator'
import AboutCardBase from '../AboutCardBase.vue'
import ExpandCollapse from '@/common/components/ExpandCollapse/ExpandCollapse.vue'
import OrderButton from '@/components/OrderButton'
import CardPicture from '@/components/Card/CardPicture.vue'

@Component({
  components: { OrderButton, ExpandCollapse, CardPicture }
})
class AboutCardTbByAlfa extends AboutCardBase {
  get depositLocalizedLink () {
    return this.$t(
      'Бесплатное пополнение карты с карт других банков %(link_start)sпо ссылке%(link_stop)s.',
      { link_start: this.depositLink.linkStart, link_stop: this.depositLink.linkStop }
    )
  }

  get depositLinkAllBanks () {
    return this.$t(
      'Бесплатное пополнение с карты любого банка Беларуси %(link_start)sпо ссылке%(link_stop)s.',
      { link_start: this.depositLink.linkStart, link_stop: this.depositLink.linkStop }
    )
  }

  get orderLocalizedLink () {
    return this.$t(
      '%(link_start)sЗакажи%(link_stop)s карту Tanks Blitz и %(link_start_bind)sпривяжи%(link_stop_bind)s карту к игровому аккаунту.',
      {
        link_start: this.orderLinkBY.linkStart,
        link_stop: this.orderLinkBY.linkStop,
        link_start_bind: this.bindLink.linkStart,
        link_stop_bind: this.bindLink.linkStop
      }
    )
  }

  get benefitsLocalizedLink () {
    return this.$t(
      'И это далеко не всё! Весь список преимуществ — %(link_start)sздесь%(link_stop)s.',
      { link_start: this.benefitsLink.linkStart, link_stop: this.benefitsLink.linkStop }
    )
  }
}

export default AboutCardTbByAlfa
</script>

<style lang="scss" src="../about-card.scss"></style>
